import React from 'react';
import styles from "../../styles/components/demandFilters.module.scss";

export default function index(props) {
  //console.log("filterMobile", props);
  delete props.previousState.offset

  const [relatedValues, setRelatedValues] = React.useState({})
   
     function camelize(str) {
       return str
         .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
           return index === 0 ? word.toLowerCase() : word.toUpperCase();
         })
         .replace(/\s+/g, "");
     }
     React.useEffect(() => {
      //console.log(props.setMobileFilterRelatedInfo)
       setRelatedValues(props.mobileFilterRelatedInfo)
       setFilterState(props.previousState)
     }, [])




     React.useEffect(() => {
      //console.log(relatedValues, "RELATEDVALUES")
     }, [relatedValues])


const initialFilterButtonState = {0 : false, 1 : false, 2 : false, 3 : false}    
const [filterButtonsState, setFilterButtonState] = React.useState({...initialFilterButtonState, 0:true})
const [filterState, setFilterState] = React.useState({})




const radioChange = (e, haveRelated) => {
    //console.log(haveRelated, "HAVErELATED")
    if (e.target.value == "None") {
        let newFilterState = filterState
        let relatedValuesToChange = relatedValues
        let extractGrandChildCheck = props.filterMobileData.filter((item) => item.field_label == haveRelated)
       // props.setLength(0)
     
       //console.log(filterState, "filterstate in radio change")
        if (extractGrandChildCheck.length > 0){
          extractGrandChildCheck = extractGrandChildCheck[0]
          delete newFilterState[camelize(extractGrandChildCheck.field_related_dropdown)]
          delete relatedValuesToChange[(extractGrandChildCheck.field_related_dropdown)]
        }
       //console.log(filterState, "filterstate in after radio change")
       //console.log(haveRelated, "HAVErELATED")
        delete newFilterState[e.target.name]
        delete newFilterState[camelize(haveRelated)]
      //  delete newFilterState[]
        
        setFilterState({...newFilterState})
        
        delete relatedValuesToChange[(haveRelated)]
        
        setRelatedValues({...relatedValuesToChange})
    }
    else {
 if (haveRelated!= "") {
     props.filterMobileData.map((item, index) => {
         if (item.field_label == haveRelated) {
             //console.log(item.field_title, "itemsss", e.target.name)
             //console.log(item.field_dropdown_option_component.filter((item) => item.field_title == e.target.value))
            let selectedRelatedParent =  item.field_dropdown_option_component.filter((item) =>  item.field_title == e.target.value ) 
            //console.log(selectedRelatedParent, "selectedrelated", haveRelated)
            setRelatedValues({ ...relatedValues, [haveRelated] : selectedRelatedParent[0].field_options})
         }
     })
 }
  setFilterState({...filterState, [e.target.name] : e.target.value})
}
}


React.useEffect(() => {
//console.log(filterState, "check123")
}, [filterState])




  const filterButtonClicked = (index) => {
    //console.log('index--', index);
    setFilterButtonState({...initialFilterButtonState, [index] : true})
}


const applyFilter = () => {
    //console.log(filterState, "filterState")
    props.setState(filterState)
    props.setFilterActive(false)
    props.setMobileFilterRelatedInfo(relatedValues)
    let filterFlag = 0
    for (let i in filterState){
      //console.log(filterState[i] , "filter state ki i")
        if((filterState[i]) !== "" && (filterState[i]) !== undefined && (filterState[i]) !== null && i != "kfa"){
          //console.log(props.length, "yaich chaiyee")
          filterFlag = filterFlag+1
          //console.log("test");
        }
      
        
        
        // if((filterState[i]) == "None"){
        //   props.setLength(length - 1)
        //   console.log(" no test");
        // }
      }
      props.setLength(filterFlag)
}
  //console.log(props.filterMobileData);  
    return (
      <div className={styles.mobileFiltersWrapper}>
        <div className={styles.head}>
          <p className={styles.title}>Filters</p>
          <p className={styles.clearFilters} onClick = {() => {setFilterState({}); props.setLength(0); setRelatedValues({}); props.setFilterOn(false); props.setState(props.initialState); props.setFilterActive(false);}}>Clear All Filters</p>
        </div>
        <div className={styles.body}>
          <div className={styles.left}>
            <ul>
              {props.filterMobileData.map((item, index) => { 
                  if (item.field_input_type == "Related Dropdown" && relatedValues[item.field_label] == null) {
                      return null
                  }
                  else {
                  return (
                <li
                  className={filterButtonsState[index] ? styles.active : null}
                  onClick={() => filterButtonClicked(index)}
                >
                  {item.field_label}
                </li>
              ) }
              }
              )}
             
            </ul>
          </div>
          <div className={styles.right}>
            <ul>
              {props.filterMobileData.map((item, index) =>
                filterButtonsState[index] ? (
                  <ul onChange = {(e) => radioChange(e, item.field_related_dropdown)}>
                     <li>  
                     <label className={styles.radioWrapper}>
                       <input
                         type="radio"
                         className={styles.radioBox}
                          value={"None"}
                          name={camelize(item.field_label)}
                          checked={
                             filterState[camelize(item.field_label)] == undefined ? true : false
                          }
                       />
                       <span className={styles.radioCheckmark}></span>
                       <span className={styles.subLabel}>{"None"}</span>
                     </label>
                   </li>
                    {
                     item.field_input_type == "Related Dropdown" ? 
                     relatedValues[item.field_label].map((optionItem, optionIndex) =>   
                     <li>  
                     <label className={styles.radioWrapper}>
                       <input
                         type="radio"
                         className={styles.radioBox}
                          value={optionItem}
                          name={camelize(item.field_label)}
                          checked={
                            optionItem == filterState[camelize(item.field_label)] ? true : false
                          }
                       />
                       <span className={styles.radioCheckmark}></span>
                       <span className={styles.subLabel}>{optionItem}</span>
                     </label>
                   </li>)
                    :
                    item.field_options.map((optionItem, optionIndex) => (
                      <li>
                       
                        <label className={styles.radioWrapper}>
                          <input
                            type="radio"
                            className={styles.radioBox}
                             value={optionItem}
                             name={camelize(item.field_label)}
                             checked={
                               optionItem == filterState[camelize(item.field_label)] ? true : false
                             }
                          />
                          <span className={styles.radioCheckmark}></span>
                          <span className={styles.subLabel}>{optionItem}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
            </ul>
          </div>
        </div>
        <div className={styles.foot}>
          <span className={styles.cancelBtn} onClick = {() => {props.setFilterActive(false)}}>Cancel</span>
          <span className={styles.applyBtn} onClick = {applyFilter}>Apply</span>
        </div>
      </div>
    );
}
